module.exports = __webpack_public_path__ + "static/media/Japan_Spain.d1c5e23c.jpeg";